import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

export const useWebContent = () => {
  return useQuery({
    queryKey: ['webContent'],
    queryFn: async ({ signal }) => {
      const response = await api.get('/web-content/get-home-content', {
        signal,
        timeout: 15000,
      });
      return response.data;
    },
    staleTime: 3 * 60 * 1000, // 3 minutes
    gcTime: 3 * 60 * 1000, // 3 minutes
    refetchOnWindowFocus: false, // Avoid unnecessary fetches
    retry: 1,
  });
};
